module.exports = __webpack_public_path__ + "img/currency-dollar-circle.4877ec3c.svg";